import { Component, inject } from '@angular/core';
import { OnInit, AfterViewInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AsyncPipe, CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableDataSource } from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import { SavedProductsApi } from '@app/services/savedproducts-api.service';
import {
  PaginatedResponse,
  RecursiveInterface,
} from '@app/services/base-authenticated.service';
import { NgForm } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import {
  MatPaginator,
  MatPaginatorModule,
  PageEvent,
} from '@angular/material/paginator';
import { ViewChild } from '@angular/core';
// import { LayoutComponent } from '../layout/layout.component';
import { ActivatedRoute } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import { Router } from '@angular/router';
import { ConfirmInvoiceDeleteComponent } from '@app/confirm-delete-dialog/confirm-delete-dialog.component';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { LoadingDialogComponent } from '@app/loading-dialog/loading-dialog.component';
import { ChangeDetectorRef } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BackHeaderComponent } from '@app/back-header/back-header.component';
import { ReferralRequestApi } from '@app/services/referral-request-api.service';
import { ReferralRequestInterface } from '@app/interface/referral-request';
import { OrganizationApi } from '@app/services/organization-api.service';
import { Organizations } from '@app/interface/organizations';
import { ReferralRequestDialogComponent } from '@app/referral-request-dialog/referral-request-dialog.component';
import {
  NewReferralRequestDialogComponent,
  NewReferralRequestPage1DialogComponent,
  NewReferralRequestPage3DialogComponent,
} from '@app/new-referral-request-dialog/new-referral-request-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ToastService } from '@app/services/toast.service';

@Component({
  selector: 'izy-referral-request-table',
  imports: [
    CommonModule,
    MatTableModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    // MatPaginator,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatListModule,
    MatMenuModule,
    // MatChipOption,
    MatChipsModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    BackHeaderComponent,
  ],
  standalone: true,
  templateUrl: './referral-request-table.component.html',
  styleUrl: './referral-request-table.component.scss',
})
export class ReferralRequestTableComponent {
  private toast = inject(ToastService);

  // Ritardi dei tooltip, stessi valori del resto dell'app.
  showDelay = new FormControl(200);
  hideDelay = new FormControl(1000);

  isLoading: boolean = false; // Initialize as false by default
  errorMessage: string | null = null;

  organization_data: Organizations | null = null;

  allReferralRequests: ReferralRequestInterface[] = [];

  constructor(
    private referralRequestApi: ReferralRequestApi,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    public organizationService: OrganizationApi,
  ) {}

  ngOnInit() {
    this.loadReferralRequests();
    this.getOrganizationData();

    // Initialize filteredOptions after companies are loaded
    // this.filteredOptions = this.myControl.valueChanges.pipe(
    //   startWith(''),
    //   debounceTime(300),
    //   map((value: any) => this._filter(value || ''))
    // );

    this.cdr.detectChanges();
  }

  private getOrganizationData() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.isLoading = true;

    const filterParams = {
      organization_id: organization_id,
    };

    this.organizationService
      .getOrganization<Organizations>(organization_id, filterParams)
      .subscribe({
        next: (organization_data: Organizations) => {
          console.log('Organization:', organization_data);
          this.organization_data = organization_data;

          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          this.isLoading = false;
          console.error('Error loading organization:', err);
          this.showErrorMessage('Failed to load organization');
          this.cdr.detectChanges();
        },
      });
  }

  private loadReferralRequests() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.isLoading = true;
    this.errorMessage = null;

    const filterParams: any = {};
    filterParams.is_deleted = false;

    this.referralRequestApi
      .getAllReferralRequests<ReferralRequestInterface>(
        organization_id,
        filterParams,
      )
      .subscribe({
        next: (response: RecursiveInterface<ReferralRequestInterface>) => {
          if (response.completed) {
            // All companies loaded across all pages
            const AllSavedProducts = response.results;

            // Update data source with all companies
            this.allReferralRequests = AllSavedProducts;

            // Extract company names from the complete dataset
            // this.savedProductSource = AllSavedProducts.map(
            //   (savedProduct) => savedProduct.name
            // );

            // console.log('All referral requests loaded', AllSavedProducts.length);
          } else {
            // Optional: Show loading progress
            console.log(
              `Loaded ${response.results.length} referral requests so far...`,
            );
          }
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          this.isLoading = false;
          console.error('Error loading products:', err);
          this.showErrorMessage('Errore durante il caricamento.');
          this.cdr.detectChanges();
        },
      });
  }

  getReferralTypeDisplay(value: string | null | undefined): string {
    if (value === null || value === undefined) return 'Non specificato';

    const statusMap: Record<string, string> = {
      PENDING: 'In attesa',
      ACCEPTED: 'Accettato',
      EXPIRED: 'Scaduto',
      FAILED: 'Rifiutato',
    };

    return statusMap[value] || 'Non specificato';
  }

  /**
   * Classe della chip di stato: la tinta racconta a che punto e' la richiesta,
   * con la stessa grammatica delle chip di stato delle altre tabelle - accent
   * per il passaggio non ancora concluso, petrol pieno per l'esito positivo,
   * bianco bordato per cio' che non e' piu' in corso, warn per il rifiuto.
   */
  getStatusChipClass(value: string | null | undefined): string {
    const chipMap: Record<string, string> = {
      PENDING: 'status-chip--pending',
      ACCEPTED: 'status-chip--accepted',
      EXPIRED: 'status-chip--expired',
      FAILED: 'status-chip--failed',
    };

    return (value && chipMap[value]) || 'status-chip--expired';
  }

  openReferralDetailsDialog(referralRequest: ReferralRequestInterface): void {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    if (!organization_id) {
      this.showErrorMessage('Impossibile gestire abbonamento: dati mancanti');
      return;
    }

    const dialogRef = this.dialog.open(ReferralRequestDialogComponent, {
      width: '90vw',
      maxWidth: '400px',
      height: 'auto',
      minHeight: '350px',
      // Superficie del dialog in linguaggio BEIZY (bordo nero 2px, angolo
      // basso-sinistra vivo): la regola e' globale in styles.scss perche' il
      // dialog vive nell'overlay CDK.
      panelClass: 'izy-dialog-panel',
      data: {
        request: referralRequest,
        organizationId: organization_id,
        organization: this.organization_data,
      },
    });
  }

  async openNewReferralDialog() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    if (isNaN(organization_id) || !organization_id) {
      this.showErrorMessage('ID organizzazione non valido');
      return;
    }

    // Step 1: Open Page 1 dialog
    const dialogRefPage1 = this.dialog.open(
      NewReferralRequestPage1DialogComponent,
      {
        width: '90vw',
        maxWidth: '600px',
        height: 'auto',
        maxHeight: '90vh',
        disableClose: false,
        panelClass: 'izy-dialog-panel',
      },
    );

    // Wait for Page 1 result
    const resultPage1 = await dialogRefPage1.afterClosed().toPromise();

    if (!resultPage1) {
      // User cancelled or didn't proceed from page 1
      return;
    }

    // Step 2: Open Page 2 dialog (main creation dialog)
    const dialogRefPage2 = this.dialog.open(NewReferralRequestDialogComponent, {
      width: '90vw',
      maxWidth: '600px',
      height: 'auto',
      maxHeight: '90vh',
      data: {
        organizationId: organization_id,
        page1Data: resultPage1.formData, // Pass data from page 1 if needed
      },
      disableClose: true,
      panelClass: 'izy-dialog-panel',
    });

    // Wait for Page 2 result (the actual creation)
    const resultPage2 = await dialogRefPage2.afterClosed().toPromise();

    if (!resultPage2) {
      // Creation failed or was cancelled - show error message
      this.showErrorMessage('Creazione della richiesta fallita o annullata.');
      return;
    }

    // If we get here, the referral request was created successfully!

    // Step 3: Open Page 3 dialog (success/confirmation page)
    const dialogRefPage3 = this.dialog.open(
      NewReferralRequestPage3DialogComponent,
      {
        width: '90vw',
        maxWidth: '600px',
        height: 'auto',
        maxHeight: '90vh',
        disableClose: false,
        panelClass: 'izy-dialog-panel',
      },
    );

    // Wait for Page 3 to close (optional)
    const resultPage3 = await dialogRefPage3.afterClosed().toPromise();

    // Update the list with the newly created request
    this.allReferralRequests = [resultPage2, ...this.allReferralRequests];
    this.showSuccessMessage('Nuova richiesta creata con successo!');
    this.cdr.detectChanges();

    // You can handle page 3 result if needed
    if (resultPage3) {
      console.log('Page 3 closed with result:', resultPage3);
    }
  }

  redirectToPortaUnAmico() {
    window.open('https://www.beizy.it/porta-un-amico', '_blank');
    // or window.location.href = 'https://your-external-link.com';
  }

  backToDashboard(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/dashboard`]);
  }

  private showSuccessMessage(message: string): void {
    this.toast.success(message);
  }

  private showErrorMessage(message: string): void {
    this.toast.error(message);
  }
}
